export function onlyOnce(fn, debugFuncName) {
    const fn_ = fn;
    let called = false;
    const errorMessage = debugFuncName
        ? `${debugFuncName} is called more than once but it shouldn't`
        : "A function is called more than once but it shouldn't";
    const newFn = (...args) => {
        if (called) {
            throw new Error(errorMessage);
        }
        called = true;
        return fn_(...args);
    };
    return newFn;
}
export function noop() {
    // do nothing
}
export function unreachable(...args) {
    console.error(args);
    throw new Error("unreachable");
}
export function unimplemented() {
    throw new Error("unimplemented");
}
//# sourceMappingURL=functions.js.map